export const apiResponseTypeEnum = {
  OPERATION_SUCCESS: 'OPERATION_SUCCESS',
  SERVER_ERROR: 'SERVER_ERROR',
  ALREADY_REGISTERED: 'ALREADY_REGISTERED',
  BLOCKED_USER: 'BLOCKED_USER',
  CAMPAIGN_CLOSED: 'CAMPAIGN_CLOSED',
  MSISDN_INVALID: 'MSISDN_INVALID',
  MSISDN_NOT_EXIST: 'MSISDN_NOT_EXIST',
  MSISDN_BLACKLISTED: 'MSISDN_BLACKLISTED',
  WRONG_PIN: 'WRONG_PIN',
  PIN_EXPIRED: 'PIN_EXPIRED',
  THIRD_PARTY_PIN_REQUEST_FAILED: 'THIRD_PARTY_PIN_REQUEST_FAILED',
  THIRD_PARTY_PIN_VERIFICATION_FAILED: 'THIRD_PARTY_PIN_VERIFICATION_FAILED',
  THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED: 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED',
  BILLING_FAILED: 'BILLING_FAILED',
  NO_BALANCE: 'NO_BALANCE',
  EVENT_LOCKED: 'EVENT_LOCKED',
  NO_AVAILABLE_GAMES: 'NO_AVAILABLE_GAMES',
  ALREADY_PLAYED: 'ALREADY_PLAYED',
};
